import { ProductLinePermission } from 'src/app/core/interfaces/permissions';
import { BrandIqBasicPage } from './pages';
import { BrandIq } from './brandiq.setup';

export const BrandIqModule: ProductLinePermission = {
  id: BrandIq.id,
  title: 'PAGE.BRANDIQ.TITLE',
  path: BrandIq.path,
  pages: [BrandIqBasicPage],
  showInSidebar: true,
  iconClass: 'fal fa-server fa-flip-horizontal',
};
